module.exports = __webpack_public_path__ + "img/american-robin.04130037.jpg";